import { Currency } from '@nemuru-eng/js-api-client';

import { loanStatusExternalValues } from '@/components/modules/Metrics/ChannelAgentMetricViews/constants/LoanStatusExternalValues';
import { MerchantChannelAgentMetricViews } from '@/components/modules/Metrics/shared/components/MerchantChannelAgentMetricViews';
import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';
import { useMetricMerchantChannelAgentViews } from '@/components/modules/Metrics/shared/hooks/useMetricMerchantChannelAgentViews';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';

const currency = Currency.EUR;

interface MetricMerchantGroupViewsProps {
  merchantIds: string[];
  timeInterval: TimeInterval;
}

export const MetricMerchantGroupViews = ({ merchantIds, timeInterval }: MetricMerchantGroupViewsProps) => {
  const { filteredMetrics, hasRequested } = useMetricMerchantChannelAgentViews({
    currency,
    timeInterval,
    loanStatusExternal: loanStatusExternalValues,
    merchantIds,
  });

  if (!timeInterval) {
    return <PendingDataWarning type={PendingDataType.NO_METRICS_INFORMATION} />;
  }

  return (
    <MerchantChannelAgentMetricViews
      currency={currency}
      timeInterval={timeInterval}
      loanStatusExternal={loanStatusExternalValues}
      filteredMetrics={filteredMetrics}
      hasRequested={hasRequested}
    />
  );
};
